export default function promiseAll(promises) {
    return Promise.all(promises);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/util/promise-all.js
// module id = 1339
// module chunks = 0